import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = {
  key: 0,
  ref: "modal",
  tabindex: "0",
  class: "justify-center items-center flex bg-overlay fixed inset-0 z-50 overflow-hidden"
}
const _hoisted_2 = { class: "flex flex-no-wrap h-full" }
const _hoisted_3 = {
  style: {"width":"940px"},
  class: "relative"
}
const _hoisted_4 = { class: "flex flex-row justify-between border-b-2" }
const _hoisted_5 = { class: "text-20px font-semibold my-5 mx-4" }
const _hoisted_6 = { class: "my-5 mx-4" }
const _hoisted_7 = { class: "flex flex-col p-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Gagal dikirim (CODREJ) ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Gagal dikirim (DEX) ")
const _hoisted_10 = { class: "flex flex-row mt-4 border-b-2 pb-6" }
const _hoisted_11 = { class: "flex flex-row mt-2" }
const _hoisted_12 = { class: "flex justify-end pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Title = _resolveComponent("Title")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          style: `height: ${_ctx.isErrorCaptionHeight ? '40rem' : '45rem'}`,
          class: "relative bg-white text-gray-lp-300 max-w-full flex-col flex rounded-lg"
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.titlePopupSetorHarian), 1),
                _createVNode("div", _hoisted_6, [
                  _createVNode("img", {
                    src: _imports_0,
                    class: "w-6 cursor-pointer",
                    style: {"top":"1.5rem","right":"1.5rem"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.forceCloseDialog && _ctx.forceCloseDialog(...args))),
                    alt: "close-icon"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.actorName,
                  value: _ctx.detailData.courierName,
                  class: "mt-2"
                }, null, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  label: "Uang yang harus disetor",
                  value: _ctx.formatPriceRp(_ctx.detailData.depositMoney),
                  class: "mt-4",
                  "data-testid": "cod-deposit-display-total"
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  label: "Jumlah STT yang harus disetor",
                  class: "mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", null, [
                      _createVNode("span", null, [
                        _hoisted_8,
                        _createVNode("strong", null, _toDisplayString(_ctx.detailData.sttCodrej) + " STT", 1)
                      ])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", null, [
                        _hoisted_9,
                        _createVNode("strong", null, _toDisplayString(_ctx.detailData.sttDex) + " STT", 1)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_DataWrapper, {
                    label: "Tanggal STT",
                    class: "w-2/4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Datepicker, {
                        class: "mt-1.5",
                        modelValue: _ctx.form.date,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.date = $event)),
                        maxDate: _ctx.maxDate,
                        onSelected: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelectDatePicker(_ctx.form.date))),
                        disabled: ""
                      }, null, 8, ["modelValue", "maxDate"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "Uang yang disetor",
                    class: "w-2/4 ml-8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LpInput, {
                        modelValue: _ctx.form.deposit,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.deposit = $event)),
                        placeholder: "e.g 100.000",
                        prefix: _ctx.prefixCurrency,
                        format: _ctx.formatMoney,
                        disabled: _ctx.detailData.depositMoney === 0,
                        onChange: _cache[5] || (_cache[5] = value => _ctx.validationInput(value, 'deposit')),
                        class: "py-3",
                        error: _ctx.isErrorDeposit,
                        errorCaption: "Masukkan jumlah sesuai dengan uang yang harus disetor",
                        isErrorIconInput: false,
                        "data-testid": "cod-deposit-input-amount"
                      }, null, 8, ["modelValue", "prefix", "format", "disabled", "error"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_Title, {
                  label: "STT yang disetor",
                  class: "mt-4"
                }),
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_DataWrapper, {
                    label: "(Gagal Kirim - CODREJ)",
                    class: "w-2/4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LpInput, {
                        modelValue: _ctx.form.CODREJ,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.CODREJ = $event)),
                        placeholder: "e.g 15",
                        class: "py-3",
                        onChange: _cache[7] || (_cache[7] = value => _ctx.validationInput(value, 'codrej')),
                        disabled: _ctx.detailData.sttCodrej === 0,
                        format: _ctx.formatNumber,
                        error: _ctx.isErrorCodrej,
                        errorCaption: "Masukan jumlah sesuai dengan STT yang harus disetor gagal kirim CODREJ",
                        isErrorIconInput: false
                      }, null, 8, ["modelValue", "disabled", "format", "error"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "(Gagal Kirim - DEX)",
                    class: "w-2/4 ml-8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LpInput, {
                        modelValue: _ctx.form.DEX,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.DEX = $event)),
                        placeholder: "e.g 15",
                        class: "py-3",
                        disabled: _ctx.detailData.sttDex === 0,
                        onChange: _cache[9] || (_cache[9] = value => _ctx.validationInput(value, 'dex')),
                        format: _ctx.formatNumber,
                        error: _ctx.isErrorDex,
                        errorCaption: "Masukan jumlah sesuai dengan STT yang harus disetor gagal kirim DEX",
                        isErrorIconInput: false
                      }, null, 8, ["modelValue", "disabled", "format", "error"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_LpButton, {
                    title: "Batal",
                    outline: "",
                    textColor: "red-lp-100",
                    class: "mt-2 mr-4",
                    onClick: _ctx.forceCloseDialog
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_LpButton, {
                    title: "Simpan",
                    textColor: "white",
                    class: "mt-2",
                    disabled: _ctx.isDisabled,
                    onClick: _ctx.postCourierDailyDeposit
                  }, null, 8, ["disabled", "onClick"])
                ])
              ])
            ])
          ])
        ], 4)
      ], 512))
    : _createCommentVNode("", true)
}